import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice401kHistoryReport extends Layout {
    checkboxIncludeSettlemt: Checkbox;
    excludabletextboxPayeeId: ExcludableTextbox;
    officeHistory401kDatasource: DataSource;
    switchReportType: Switch;
    textboxOffice401kHistCheckDate: Textbox;
}
